import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles(() => ({
  container: {
    width: '100%',
    flex: 1
  },
  tableContainer: {
    width: '100%'
  },
  vaultListTable: {
    '& .__tr .__td': {
      display: 'flex',
      alignItems: 'center'
    },
    '& .__tr.even .__td': {
      backgroundColor: 'var(--color-neutral-100) !important'
    }
  }
}))
